<template>
  <el-table-column
    prop="username"
    sortable="custom"
    label="Felhasználónév"
    show-overflow-tooltip
    width="150"
  />
</template>

<script>
export default {
  propName: 'username',
};
</script>
